import { imgUrl } from "../../config/api";

export function convertTempToFiles(temp) {
  const images =
    temp.uploadedImagesURL?.map((url, idx) => ({
      id: `restored-img-${Date.now()}-${idx}-${temp.uploadedImagesFile?.[idx] || ""}`,
      name: temp.uploadedImagesFile?.[idx] || "unknown",
      url: imgUrl(url),
      size: 0,
      type: "image/" + url.split(".").pop(),
      status: "success",
      uploadedAt: new Date(0),
    })) || [];
  const pdfs =
    temp.uploadedPDFURL?.map((url, idx) => ({
      id: `restored-pdf-${Date.now()}-${idx}-${temp.uploadedPDFFile?.[idx] || ""}`,
      name: temp.uploadedPDFFile?.[idx] || "unknown",
      url: imgUrl(url),
      size: 0,
      type: "application/pdf",
      status: "success",
      uploadedAt: new Date(0),
    })) || [];
  return { images, pdfs };
}
